<template>
  <div v-if="selectedHeartBeat">
    <template v-if="true">
      <div v-if="!roomId">
        <h6>Create Room</h6>
        <b-button block variant="primary" @click="handleCreateRoom">
          CREATE ROOM
        </b-button>
      </div>
      <div v-else-if="roomId && roomData && !roomData.token">
        <h6>Lobby</h6>
        <section id="previewContainer">
          <div id="myPreviewVideo">
            [PREVIEW]
          </div>
          <div
              id="select-devices"
              v-if="optsAudio && Array.isArray(optsAudio) && optsAudio.length > 0"
          >
            <div>
              <label>Audio Source:</label>
              <b-form-select v-model="selectedAudio" :options="optsAudio" />

              <br />
              <label>Video Source:</label>
              <b-form-select v-model="selectedVideo" :options="optsVideo" />
            </div>
          </div>
          <br />
        </section>
        <b-button @click="handleAVRequestAccess">
          Request Access
        </b-button>
        <b-button @click="handleStartPreview">
          Preview Selection
        </b-button>
        <b-button block variant="primary" @click="handleJoinRoom">
          Join
        </b-button>
      </div>
    </template>
    <div style="height: 75vh; background-color: #222222">
      <section id="VEcontainer">
        <div id="roomContainer" style="height: 500px;">
        </div>
        <div id="mySection">
          <div
              id="publisher"
              class="update-profile-btn"
          />
          <div
              id="publisherScreenShare"
          />
        </div>
      </section>
    </div>
    <div
        style="background-color: #222222; height: 10vh"
    >
      <div style="background-color: #d4ad49; border-radius: 10px; padding: 15px;
      margin-right: 10px;
        margin-left: 10px;">
        <b-iconstack id="p_audio_control" :font-scale="controlsFontScale"
                     style="cursor:pointer; margin: 5px"
                     @click="handleToggleAudio">
          <b-icon stacked icon="circle-fill"
                  variant="dark"/>
          <b-icon stacked icon="mic-fill"
                  variant="light"
                  scale="0.5"
                  shift-v="-0.25"
          />
          <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
        </b-iconstack>
        <b-iconstack id="p_video_control" :font-scale="controlsFontScale"
                     style="cursor:pointer; margin: 5px;"
                     @click="handleToggleVideo">
          <b-icon stacked icon="circle-fill"
                  variant="dark"/>
          <b-icon stacked icon="camera-video"
                  variant="light"
                  scale="0.5"
                  shift-v="-0.25"
          />
          <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
        </b-iconstack>
        <b-iconstack id="p_layout_control" :font-scale="controlsFontScale"
                     style="cursor:pointer; margin: 5px"
                     @click="handleToggleLayout">
          <b-icon stacked icon="circle-fill"
                  variant="dark"/>
          <b-icon stacked icon="layout-wtf"
                  variant="light"
                  scale="0.5"
                  shift-v="-0.25"
          />
          <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
        </b-iconstack>
        <b-iconstack id="p_enterexitcontrol" :font-scale="controlsFontScale"
                     style="cursor:pointer; margin: 5px"
                     @click="handleLeaveRoom">
          <b-icon stacked icon="circle-fill"
                  variant="danger"/>
          <b-icon stacked icon="telephone"
                  variant="light"
                  scale="0.5"
                  shift-v="-0.25"
                  rotate="130"
          />
          <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
        </b-iconstack>
        <b-iconstack id="p_settings_control"  :font-scale="controlsFontScale"
                     style="cursor:pointer; margin: 5px"
                     @click="handleHandRaise">
          <b-icon stacked icon="circle-fill"
                  variant="dark"/>
          <b-icon stacked icon="gear"
                  variant="light"
                  scale="0.5"
                  shift-v="-0.25"
                  rotate="130"
          />
          <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
        </b-iconstack>
        <b-iconstack id="p_screenshare_control"  :font-scale="controlsFontScale"
                     style="cursor:pointer; margin: 5px"
                     @click="handleToggleScreenShare">
          <b-icon stacked icon="circle-fill"
                  variant="dark"/>
          <b-icon stacked icon="arrow-up-square"
                  variant="light"
                  scale="0.5"
                  shift-v="-0.25"
          />
          <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
        </b-iconstack>
        <b-iconstack id="p_emoji_control" :font-scale="controlsFontScale"
                     style="cursor:pointer; margin: 5px"
                     @click="handleHandRaise">
          <b-icon stacked icon="circle-fill"
                  variant="dark"/>
          <b-icon stacked icon="emoji-heart-eyes"
                  variant="light"
                  scale="0.5"
                  shift-v="-0.25"
          />
          <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
        </b-iconstack>
        <b-iconstack id="p_hand_control" :font-scale="controlsFontScale"
                     style="cursor:pointer; margin: 5px"
                     @click="handleHandRaise">
          <b-icon stacked icon="circle-fill"
                  variant="dark"/>
          <b-icon stacked icon="hand-index"
                  variant="light"
                  scale="0.5"
                  shift-v="-0.25"
          />
          <b-icon v-if="false" stacked icon="slash-circle" variant="danger"></b-icon>
        </b-iconstack>
      </div>
    </div>
    <div v-if="true" id="footer">
      <div>Room Status: {{ roomStatus }}</div>
      <div>Video Status: {{ videoStatus }}</div>
      <div>Audio Status: {{ audioStatus }}</div>
      <div>Layout Status: {{ layoutStatus }}</div>
    </div>
  </div>
  <div v-else style="height:100vh; background-color: #222222; color: #FFFFFF">
    <h6>Select HeartBeat to Join</h6>
  </div>
</template>
<script>
import firebase from "firebase";
import { getDevices, PreviewPublisher, Room } from "@vonage/video-express";

export default {
  name: "Chat_SideBar_Body_Video",
  components: {},
  props: {
    profile: {
      type: Object,
      default: null,
      required: false
    },
    messageBoxRefId: {
      type: String,
      required: true
    },
    commWith: {
      type: String,
      required: true
    },
    selectedHeartBeat: {
      type: Object,
      default: null,
      required: false
    }
  },
  created() {},
  mounted() {},
  computed: {
    videoStatus() {
      if (this.toggle && this.toggle.camera) {
        return this.toggle.camera.isVideoEnabled() ? "Enabled" : "Disabled";
      }
      return "N/A";
    }
  },
  methods: {
    setUpRoom() {
      //1.Create Room - gets session id an api from server
      //2.Load AV Resources
      //3.Join as Participant
      this.handleCreateRoom()
          .then((resp1)=> {
            console.log(resp1);
            this.handleAVRequestAccess()
                .then((resp2) => {
                  console.log(resp2);
                  if(resp2 && this.selectedVideo && this.selectedAudio)  {
                    console.log('made it here');
                    this.handleJoinRoom().then((resp) => {
                      console.log('Log');
                    }).catch((err) => {
                      console.err(`Err: ${err}`);
                    });
                  }
                }).catch((err)=>{
                console.error('Error');
            });
            //request access - loads av
          })
          .catch((err)=>{
            console.error(`Not able to create room: ${JSON.stringify(err)}`)
          });
    },
    handleCreateRoom() {
      return new Promise((res, rej) => {
        //@todo?move to store
        this.roomData.participantName = this.participantName;

        const db = firebase.firestore(); //Move to single place
        this.roomId = `heartbeat_${
            this.selectedHeartBeat && this.selectedHeartBeat.slug
                ? this.selectedHeartBeat.slug
                : "error"
        }`;
        this.roomRef = db.doc(`rooms/${this.roomId}`);

        console.log("Room name: ", this.roomId);
        this.roomStatus = "Creating the room...";

        return this.roomRef
            .get()
            .then(doc => {
              if (doc.exists) {
                this.roomRef
                    .update({
                      _updated_at: new Date()
                    })
                    .then(() => {
                      return this.subscribeToRoom(this.roomId)
                          .then((resp)=>{
                            res (resp);
                          }).catch((err)=>{
                            rej(err);
                          })
                    });
              } else {
                this.roomRef
                    .set({
                      _created_at: new Date(),
                      apiKey: "",
                      sessionId: ""
                    })
                    .then(() => {
                      return this.subscribeToRoom(this.roomId)
                          .then((resp)=>{
                            res (resp);
                          }).catch((err)=>{
                            rej(err);
                          })
                    });
              }
            })
            .catch(error => {
              console.error("Error creating room: ", error);
              this.roomStatus = "Error creating room!";
            });
      });
    },
    subscribeToRoom() {
      return new Promise((res, rej) => {
        this.unsub = this.roomRef.onSnapshot(doc => {
          let data = doc.data();
          console.log("Room Subscription Data: ", data);

          if (data.apiKey !== "" && data.sessionId !== "") { //this take time to create- bottle neck
            //Set Data
            this.roomData.apiKey = data.apiKey;
            this.roomData.sessionId = data.sessionId;
            this.roomStatus = `Room Exist!`;
            res(this.roomData)
          } else {
            rej({error:'Room does not exist'});
          }

        });
      })
    },
    subscribeToParticipant() { //unsubP- @Todo- need different subscriptions?
      return new Promise((res, rej) => {
        this.unsub = this.participantRef.onSnapshot(doc => {
          let data = doc.data();
          console.log("Current data: ", data);
          if (data.token !== "") {
            this.roomData.token = data.token;

            if (this.previewPublisher) {
              this.previewPublisher.destroy();
            }

            return this.joinRoom()
                .then((resp)=>{
                    res(resp);
                })
                .catch((err)=>{
                    rej(err);
                });
          }
        });
      });
    },
   async handleAVRequestAccess() {
     let resourcesLoaded = await this.loadAVSource();

     return new Promise((res, rej) => {
       if (resourcesLoaded) {
         res(true);
       } else {
         rej(false);
       }
     });
    },
    async loadAVSource() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        console.log("enumerateDevices() not supported.");
        return;
      }
      try {
        // Need to ask permission in order to get access to the devices to be able to list them in the dropdowns.
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true
        });
        stream.getTracks().forEach(track => track.stop());
        let audioCount = 0;
        let videoCount = 0;
        const devices = await getDevices();

        devices.forEach(device => {
          if (device.kind.toLowerCase() === "audioinput") {
            audioCount++;

            let optAudio = {
              text: device.label || ` ${device.kind}  ${audioCount}`,
              value: device.deviceId
            };
            this.optsAudio.push(optAudio);
          }

          if (device.kind.toLowerCase() === "videoinput") {
            videoCount++;
            let optVideo = {
              text: device.label || ` ${device.kind}  ${videoCount}`,
              value: device.deviceId
            };
            this.optsVideo.push(optVideo);
          }
        });

        //Set Default Source
        this.selectedAudio =
            this.optsAudio &&
            Array.isArray(this.optsAudio) &&
            this.optsAudio.length > 0 &&
            this.optsAudio[0] &&
            this.optsAudio[0].value
                ? this.optsAudio[0].value
                : null;
        this.selectedVideo =
            this.optsVideo &&
            Array.isArray(this.optsVideo) &&
            this.optsVideo.length > 0 &&
            this.optsVideo[0] &&
            this.optsVideo[0].value
                ? this.optsVideo[0].value
                : null;
        return true;
      } catch (error) {
        console.error("error loading AV sources: ", error);
      }
      return false;
    },
    handleStartPreview() {
      this.previewPublisher = new PreviewPublisher("previewContainer");
      let pubProps = {
        resolution: "1280x720",
        [this.selectedAudio === "" ? "publishAudio" : "audioSource"]:
            this.selectedAudio === "" ? false : this.selectedAudio,
        [this.selectedVideo === "" ? "publishVideo" : "videoSource"]:
            this.selectedVideo === "" ? false : this.selectedVideo,
        mirror: false,
        audioBitrate: 15,
        audioFallbackEnabled: true
      };

      this.previewPublisher.previewMedia({
        targetElement: "myPreviewVideo",
        publisherProperties: pubProps
      });
    },
    handleJoinRoom() {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        this.participantRef = db.doc(
            `rooms/${this.roomId}/participants/${this.participantName}`
        );

        return this.participantRef
            .get()
            .then(doc => {
              if (doc.exists) {
                this.participantRef
                    .update({
                      _updated_at: new Date()
                    })
                    .then(() => {
                      return this.subscribeToParticipant(this.roomId).then((resp)=>{
                        res(resp);
                      }).catch((err)=>{
                        rej(err);
                      });
                    });
              } else {
                this.participantRef
                    .set({
                      _created_at: new Date(),
                      token: ""
                    })
                    .then(() => {
                      return this.subscribeToParticipant(this.roomId).then((resp)=>{
                        res(resp);
                      }).catch((err)=>{
                        rej(err);
                      });
                    });
              }
            })
            .catch(err => {
              console.error("Error joining participant: ", err);
              rej(err);
            });
      });
    },
    async joinRoom() {
      return new Promise(async (res, rej) => {
        console.log("joinRoom room: ", this.room);
        if (!this.room) {
          console.log("create a new room");
          this.room = new Room({
            apiKey: this.roomData.apiKey, // add your OpenTok APIKey
            sessionId: this.roomData.sessionId, // add your OpenTok Session Id
            token: this.roomData.token, // add your OpenTok token
            participantName: this.roomData.participantName,
            roomContainer: "roomContainer",
            managedLayoutOptions: {
              cameraPublisherContainer: "publisher"
            }
          });
        }

        const {camera, screen} = this.room;

        this.toggle.camera = camera;

        try {
          let pubProps = {
            resolution: "250x250",//"1280x720",
            [this.selectedAudio === "" ? "publishAudio" : "audioSource"]:
                this.selectedAudio === "" ? false : this.selectedAudio,
            [this.selectedVideo === "" ? "publishVideo" : "videoSource"]:
                this.selectedVideo === "" ? false : this.selectedVideo,
            mirror: true,
            audioBitrate: 6000,
            audioFallbackEnabled: true
          };
          await this.room.join({
            publisherProperties: pubProps
          });

        } catch (error) {
          rej(error);
          console.error("Error joining room: ", error)``;
        }

        this.audioStatus = camera.isAudioEnabled() ? "enabled" : "disabled";

        /*
      const startScreensharing = () => {
        this.room.startScreensharing("publisherScreenShare");
      }
      const stopScreensharing = () => {
        this.room.stopScreensharing();
      }
      screenshareStartBtn.addEventListener("click", startScreensharing, false);
      screenshareStopBtn.addEventListener("click", stopScreensharing, false);

      */

        screen.on("started", () => {
          this.toggle.isScreenSharing = true;
          console.log("The screen sharing has started!");
        });

        screen.on("stopped", () => {
          this.toggle.isScreenSharing = false;
          console.log("The screen stopped sharing because: ");
        });

        this.room.on("connected", async () => {
          console.log("room connected!");
        });

        this.room.on("participantJoined", participant => {
          console.log("participantJoined: ", participant);
          participant.on("cameraCreated", cameraSubscriber => {
            console.log("Participant camera created! ", cameraSubscriber);
          });
          participant.on("cameraDestroyed", reason => {
            console.log("Participant camera destroyed!", reason);
          });
          participant.on("screenCreated", screenSubscriber => {
            console.log("Participant Screen created!", screenSubscriber);
          });
          participant.on("screenDestroyed", reason => {
            console.log("Participant Screen destroyed!", reason);
          });
          participant.on("destroyed", reason => {
            console.log("Participant Screen destroyed!", reason);
          });
        });

        this.room.on("disconnected", () => {
          console.log("room disconnected!");
        });

        this.room.on("reconnecting", () => {
          console.log("room reconnecting!");
        });

        this.room.on("reconnected", () => {
          console.log("room reconnected!");
        });

        res(true);
      });
    },
    /** CONTROLS **/
    handleToggleVideo() {
      if (this.toggle.camera) {
        console.log(
            "camera.isVideoEnabled()",
            this.toggle.camera.isVideoEnabled()
        );

        if (this.toggle.camera.isVideoEnabled()) {
          this.toggle.camera.disableVideo();
          this.videoStatus = "disabled";
        } else {
          this.toggle.camera.enableVideo();
          this.videoStatus = "enabled";
        }
      }
    },
    handleToggleAudio() {
      if (this.toggle.camera) {
        console.log(
            "camera.isAudioEnabled()",
            this.toggle.camera.isAudioEnabled()
        );

        if (this.toggle.camera.isAudioEnabled()) {
          this.toggle.camera.disableAudio();
          this.audioStatus = "disabled";
        } else {
          this.toggle.camera.enableAudio();
          this.audioStatus = "enabled";
        }
      }
    },
    handleToggleLayout() {
      if (this.toggle.camera) {
        console.log(`Layout Status is  ${this.layoutStatus}`);
        if (this.layoutStatus === "grid") {
          this.room.setLayoutMode("active-speaker");
          this.layoutStatus = "active speaker";
        } else {
          this.room.setLayoutMode("grid");
          this.layoutStatus = "grid";
        }
      }
    },
    handleToggleScreenShare() {
      if (this.toggle.isScreenSharing) {
        this.room.stopScreensharing();
      } else {
        this.room.startScreensharing("publisherScreenShare");
      }
    },
    handleLeaveRoom() {
      this.roomData.token = null;
      this.room.leave();
      //this.handleStartPreview();
    },
    handleHandRaise() {

    },
    handleToggleSettings(){
      this.toggle.showSettings = !this.toggle.showSettings;
    }
  },
  watch: {
    selectedHeartBeat(val) {
      if (val) {
        this.setUpRoom();
      }
    },
  },
  data() {
    return {
      controlsFontScale:2,
      participantName:
          this.profile && this.profile.firstname ? this.profile.firstname : null,
      roomData: {
        apiKey: null,
        sessionId: null,
        token: null,
        participantName: null
      },
      toggle: {
        camera: null,
        audio: null,
        layoutStatus: null,
        isScreenSharing: false,
        showSettings: false
      },
      unsub: null,
      roomId: "",
      roomRef: "",
      participantRef: "",
      roomStatus: "",
      audioStatus: "",
      layoutStatus: "",
      optsAudio: [],
      selectedAudio: null,
      optsVideo: [],
      selectedVideo: null,
      previewPublisher: null,
      room: null
    };
  }
};
</script>

<style lang="scss" scoped>
.update-profile-btn {
  position: absolute;
  left: 15%;
  bottom: 30%;
  cursor: pointer;

}

</style>
